const bmsSx = {
  wrapper: {
    border: 'none',
    bgcolor: 'transparent !important',
    '& .MuiDataGrid-detailPanel': {
      backgroundColor: 'transparent',
    },
    '& .MuiDataGrid-container--top:not(.rack-data-table .MuiDataGrid-container--top)':
      {
        display: 'none',
      },
    '& .bms-row.MuiDataGrid-row': {
      backgroundColor: 'rgba(215, 215, 215, 0.05)',
      border: 'solid 1px rgba(215, 215, 215, 0.1)',
    },
    '& .bms-row.MuiDataGrid-row--detailPanelExpanded': {
      mb: '0 !important',
      borderBottom: 0,
    },
    '& .bms-row .MuiDataGrid-cell': {
      border: 'none',
    },
    '& .detail-panel': {
      transition: 'height 0.3s ease',
      overflow: 'hidden',
    },
  },
  detailWrapper: {
    padding: 2.5,
    mb: 1,
    boxShadow: 'none !important',
    border: 'solid 1px rgba(215, 215, 215, 0.1)',
    borderTop: 0,
    backgroundColor: 'rgba(215, 215, 215, 0.05) !important',
  },
  rackTable: {
    toolbar: {
      pt: 1,
      pb: 0.5,
      px: '20px',
    },
    bgcolor: 'transparent !important',
    borderRadius: 0,
    maxHeight: '350px',
    '& .MuiDataGrid-row': {
      backgroundColor: 'rgba(215, 215, 215, 0.05) !important',

      borderTop: 'solid 1px rgba(215, 215, 215, 0.1) !important',
    },
  },
};

export default bmsSx;
